import proteaO from "./protea-o-suave-preview.png";
import classes from "./Logo.module.css";

type LogoProps = {
  desktop?: boolean;
  mobile?: boolean;
  className?: string;
};

const Logo = ({ desktop = false, mobile = false, className = "" }: LogoProps) => {
  return (
    <div className={`${classes.container} ${desktop ? classes.desktopLogo : ""} ${mobile ? classes.mobileLogo : ""} ${className}`.trim()} aria-label="Protea">
      <span className={classes.wordmark} aria-hidden="true">
        <span>PR</span>
        <span className={classes.mark}>
          <img src={proteaO} alt="" />
        </span>
        <span>TEA</span>
      </span>
    </div>
  );
};

export default Logo;
